import { donationConstants } from './constants/donationConstants'

 const donationGetByFilter = (input) => {
	return {
		type: donationConstants.DonationGetByFilterRequest,
		input: input
  };
};

 const donationRecurringGetByFilter = (input) => {
	return {
		type: donationConstants.DonationRecurringGetByFilterRequest,
		input: input
	};
};

export const donationAction = {
	donationGetByFilter,
	donationRecurringGetByFilter
}